export default __webpack_public_path__ + "static/media/success.74bbc6b0.svg";